import { map } from 'rxjs/operators';
import { parseDate } from '../utils/date-utils';
import { BaseService } from './base-service';
export class PortalUserService {
    static getPortalUsers(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        // return BaseService.getPaginated<IPortalUserDTO[]>(`portal-users`, pageNumber);
        return BaseService.getPaginated(`portal-users?filter=${qs}`, pageNumber)
            .pipe(map(w => {
            w.payload.forEach(x => { x.lastLoginOn = parseDate(x.lastLoginOn); });
            return w;
        }));
    }
    static fetchPortalUser(oid) {
        return BaseService.get(`portal-users/${oid}`);
    }
    static savePortalUser(dto) {
        return BaseService.save(`portal-users`, dto);
    }
    static deletePortalUser(oid) {
        return BaseService.delete(`portal-users/${oid}`);
    }
    static resetPassword(dto) {
        return BaseService.post(`portal-users/reset-password`, dto);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchPortalUserCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`portal-users-combo/${selfId}?search=${qs}`);
    }
    // ----------------------------------------------------------------------
    // Roles
    // ----------------------------------------------------------------------
    static getPortalRoles() {
        return BaseService.get(`portal-roles`);
    }
    // ----------------------------------------------------------------------
    // Self Region Settings
    // ----------------------------------------------------------------------
    static fetchSelfRegionSettings() {
        return BaseService.get(`self-region-settings`);
    }
    static fetchRegionSettings() {
        return BaseService.get(`portal-settings`)
            .pipe(map(w => {
            w.payload.forEach(x => {
                x.createdOn = parseDate(x.createdOn);
                x.updatedOn = parseDate(x.updatedOn);
            });
            return w;
        }));
        ;
    }
    // ----------------------------------------------------------------------
    // Self User
    // ----------------------------------------------------------------------
    static fetchSelf() {
        return BaseService.get(`portal-users/me`);
    }
    static saveSelf(dto) {
        return BaseService.save(`portal-users/me`, dto);
    }
    static selfChangePassword(dto) {
        return BaseService.post(`portal-users/me/change-password`, dto);
    }
}
